import React, { Component } from 'react';
import Divider from 'components/Divider';
import PropTypes from 'prop-types';
import Popup from 'components/CoachPopup';
import styles from './Actionable.scss';

class Actionable extends Component {
  static propTypes = {
    updateConversation: PropTypes.func.isRequired,
    profile: PropTypes.shape().isRequired,
    request: PropTypes.shape().isRequired,
    coachEmail: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      actionableToolTip: false,
      bubbleToolTip: true,
      requestCreatedBy: 'SA',
      disableInviteToCamp: false,
      disableFillQuestionaire: false,
      disableAddedToWathcList: false,
      disableIgnored: false,
      disableNeedMoreFilms: false,
      disableSendContactInfo: false,
      showPopup: false,
    };
    this.showTooltip = this.showTooltip.bind(this);
    this.hideTooltip = this.hideTooltip.bind(this);
    this.addQuestionaire = this.addQuestionaire.bind(this);
    this.inviteToCamp = this.inviteToCamp.bind(this);
    this.needMoreFilms = this.needMoreFilms.bind(this);
    this.sendContactInfo = this.sendContactInfo.bind(this);
    this.addToWatchList = this.addToWatchList.bind(this);
    this.ignoredList = this.ignoredList.bind(this);
  }
  componentWillMount() {
    const updated = {};
    const convo = this.props.request.get('conversation');
    const allConvo = convo.toIndexedSeq().toArray();
      for(var i=0; i< allConvo.length; i++) { // eslint-disable-line
        const temp = allConvo[i];
        if (temp.get('action') === 'INVITE TO CAMP') {
          updated.disableInviteToCamp = true;
        }
        if (temp.get('action') === 'FILL QUESTIONAIRE') {
          updated.disableFillQuestionaire = true;
        }
        if (temp.get('action') === 'SA SENT CONTACT INFO') {
          updated.disableSendContactInfo = true;
        }
        if (temp.get('action') === 'ADDED TO WATCHLIST') {
          updated.disableAddedToWathcList = true;
        }
        if (temp.get('action') === 'NEED MORE FILMS') {
          updated.disableNeedMoreFilms = true;
        }
        if (temp.get('action') === 'IGNORED') {
          updated.disableIgnored = true;
        }
      }
    this.setState(updated);
  }
  componentWillReceiveProps(nextProps) {
    const updated = {};
    const convo = nextProps.request.get('conversation');
    const allConvo = convo.toIndexedSeq().toArray();
      for(var i=0; i< allConvo.length; i++) { // eslint-disable-line
        const temp = allConvo[i];
        if (temp.get('action') === 'INVITE TO CAMP') {
          updated.disableInviteToCamp = true;
        }
        if (temp.get('action') === 'FILL QUESTIONAIRE') {
          updated.disableFillQuestionaire = true;
        }
        if (temp.get('action') === 'SA SENT CONTACT INFO') {
          updated.disableSendContactInfo = true;
        }
        if (temp.get('action') === 'ADDED TO WATCHLIST') {
          updated.disableaddedToWathcList = true;
        }
        if (temp.get('action') === 'NEED MORE FILMS') {
          updated.disableNeedMoreFilms = true;
        }
        if (temp.get('action') === 'IGNORED') {
          updated.disableIgnored = true;
        }
      }
    // const lastItemInConversation = convo.last();
    this.setState(updated);
  }
  showTooltip() {
    this.setState({ actionableToolTip: !this.state.actionableToolTip });
  }
  hideTooltip() {
    this.setState({ bubbleToolTip: false, actionableToolTip: false });
  }

  addQuestionaire(requestId, email, name) {
    const conversation = {
      id: requestId,
      action: 'FILL QUESTIONAIRE', // let backend know if you change something here
      link: this.props.profile.get('question_link'),
      sa_email: email,
      sa_name: name,
      created_by: this.state.requestCreatedBy,
      coach_email: this.props.coachEmail,
    };
    this.showTooltip();
    this.setState({ showPopup: true, text: 'Hi Coach! We have notified student athlete to fill your college questionnaire.' });
    this.props.updateConversation(conversation, 'public');
  }

  inviteToCamp(requestId, email, name) {
    const conversation = {
      id: requestId,
      action: 'INVITE TO CAMP',
      created_by: this.state.requestCreatedBy,
      sa_email: email,
      sa_name: name,
      coach_email: this.props.coachEmail,
    };
    this.showTooltip();
    this.props.updateConversation(conversation, 'public');
  }

  needMoreFilms(requestId, email, name) {
    const conversation = {
      id: requestId,
      action: 'NEED MORE FILMS',
      sa_email: email,
      created_by: this.state.requestCreatedBy,
      sa_name: name,
      coach_email: this.props.coachEmail,
    };
    this.showTooltip();
    this.props.updateConversation(conversation, 'public');
  }
  addToWatchList(requestId, email, name) {
    const conversation = {
      id: requestId,
      action: 'ADDED TO WATCHLIST',
      created_by: this.state.requestCreatedBy,
      sa_email: email,
      sa_name: name,
      coach_email: this.props.coachEmail,
    };
    this.showTooltip();
    this.props.updateConversation(conversation, 'public');
  }
  ignoredList(requestId, email, name) {
    const conversation = {
      id: requestId,
      action: 'IGNORED',
      created_by: this.state.requestCreatedBy,
      sa_email: email,
      sa_name: name,
      coach_email: this.props.coachEmail,
    };
    this.showTooltip();
    this.props.updateConversation(conversation, 'public');
  }
  sendContactInfo(requestId, email, name, mobile) {
    const conversation = {
      id: requestId,
      action: 'SA SENT CONTACT INFO',
      created_by: this.state.requestCreatedBy,
      sa_email: email,
      sa_name: name,
      sa_mobile: mobile,
      coach_email: this.props.coachEmail,
    };
    this.showTooltip();
    this.setState({ showPopup: true, text: 'Hi Coach! We mailed you student athlete contact details.' });
    this.props.updateConversation(conversation, 'public');
  }

  render() {
    const item = this.props.profile;
    const { request } = this.props;
    const { disableSendContactInfo, disableFillQuestionaire } = this.state;
    return (
        /*eslint-disable*/
      <div className={this.state.actionableToolTip ? styles.fullScreen : '' } onClick={this.showTooltip}>
        <div className={styles.bubbleButton} id="actionableButton">
            {this.state.showPopup ? <Popup text={this.state.text} /> : ''}
          <button
            // onMouseEnter={this.showTooltip}
            // onMouseLeave={this.hideTooltip}
            onClick={this.showTooltip}
          >
          CONTACT PLAYER
        </button>
        </div>
        <div
          className={this.state.actionableToolTip === true ? styles.popupBubble : styles.hidden}
        >
          <span>
            {/*<button*/}
              {/*onClick={() => this.inviteToCamp(request.get('id'), item.get('sa_email'), item.get('sa_name'))}*/}
              {/*className={styles.options}*/}
              {/*disabled={this.state.disableInviteToCamp}*/}
            {/*>*/}
              {/*Invite to Camp*/}
            {/*</button>*/}
            {/*<Divider />*/}
            <button
              onClick={() => this.addQuestionaire(request.get('id'), item.get('fullname'), item.get('sa_name'))}
              className={styles.options}
              disabled={disableFillQuestionaire}
            >
             Send My Questionnaire
             </button>
            <Divider />
            <button
              onClick={() => this.sendContactInfo(request.get('id'), item.get('sa_email'), item.get('fullname'), item.get('sa_mobile'))}
              className={styles.options}
              disabled={disableSendContactInfo}
            >
             Request Student Contact Information
             </button>
            {/*<Divider />*/}
            {/*<button*/}
              {/*onClick={() => this.addToWatchList(request.get('id'), item.get('sa_email'), item.get('sa_name'))}*/}
              {/*className={styles.options}*/}
              {/*disabled={this.state.disableAddedToWathcList}*/}
            {/*>*/}
             {/*Add to Watchlist*/}
             {/*</button>*/}
            {/*<Divider />*/}
            {/*<button*/}
              {/*onClick={() => this.needMoreFilms(request.get('id'), item.get('sa_email'), item.get('sa_name'))}*/}
              {/*className={styles.options}*/}
              {/*disabled={this.state.disableNeedMoreFilms}*/}
            {/*>*/}
             {/*Need More Films*/}
             {/*</button>*/}
            {/*<Divider />*/}
            {/*<button*/}
              {/*onClick={() => this.ignoredList(request.get('id'), item.get('sa_email'), item.get('sa_name'))}*/}
              {/*className={styles.options}*/}
              {/*disabled={this.state.disableIgnored}*/}
            {/*>*/}
             {/*Not Interested*/}
             {/*</button>*/}
          </span>
        </div>
      </div>
    );
  }
}

export default Actionable;



// WEBPACK FOOTER //
// ./src/components/PublicActionableItems/Actionable.js